import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ChoiceTypeTable from '../shared/ChoiceTypeTable';
import { choiceTypeAnswerSummaryPropType } from '../../../common/propTypes';
import AggregationTable from '../shared/AggregationTable';
import { AfsPartsContainer } from '../shared/AfsPartsContainer/presenter';
import AfsTableWrapper from '../shared/AfsTableWrapper';
export var ChoiceType = /*#__PURE__*/function (_Component) {
  function ChoiceType() {
    var _this;
    _classCallCheck(this, ChoiceType);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChoiceType, [].concat(args));
    _defineProperty(_this, "render", function () {
      var _this$props = _this.props,
        answerSummary = _this$props.answerSummary,
        itemId = _this$props.itemId;
      return /*#__PURE__*/React.createElement(AfsTableWrapper, null, /*#__PURE__*/React.createElement(AfsPartsContainer, {
        afsTable: /*#__PURE__*/React.createElement(ChoiceTypeTable, {
          itemId: itemId,
          choices: answerSummary.choices
        }),
        aggregationTable: /*#__PURE__*/React.createElement(AggregationTable, {
          itemId: itemId,
          answerSummary: answerSummary
        })
      }));
    });
    return _this;
  }
  _inherits(ChoiceType, _Component);
  return _createClass(ChoiceType);
}(Component);
_defineProperty(ChoiceType, "propTypes", {
  itemId: PropTypes.number,
  answerSummary: choiceTypeAnswerSummaryPropType
}.isRequired);